export default {
  linearRegressionHeadline: 'Lineárna regresia',
  ployfit: {
    headline: 'Polynomiálne prispôsobenie',
    degree: 'Stupeň',
  },
};
